import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ArrowForward } from '@mui/icons-material';

const ComparisonTable = ({ content }) => {
  return (
    <Container
      fluid
      style={{
        background: `linear-gradient(135deg, #0a3d91, #1e72c0)`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundOrigin: 'center',
        color: 'white',
        margin: 'auto',
        minHeight: '450px',
      }}>
      <div className="container mt-4 py-5">
        <h3 className="mb-3 text-center text-white text-lg">{content.title}</h3>

        <div className="d-none d-md-block">
          <img className="mt-4" src={content.image} alt="Comparison Table" />
        </div>
        <div
          className="d-md-none"
          style={{ width: '100%', overflowX: 'scroll' }}>
          <img className="mt-4" src={content.image} alt="Comparison Table" />
        </div>

        {content.ctaText && content.ctaLink && (
          <Row className="mt-5">
            <Col>
              <p className="text-center" style={{ fontSize: '16px' }}> {content.ctaDescription} </p>
              <p className="text-center mt-5">
                <a
                  href={content.ctaLink}
                  style={{ background: 'white' }}
                  className="text-blue btn-rounded btn btn-primary">
                  {content.ctaText} <ArrowForward fontSize="16" />
                </a>
              </p>
            </Col>
          </Row>
        )}
      </div>
    </Container>
  );
};

export default ComparisonTable;
